import { CustomerInfo } from '../customer/Customer'

export enum TransferStatus {
  SUBMITTED = 'submitted',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  T0_SESSIONS = 't0_sessions',
  REVERSED = 'reversed',
  ON_HOLD = 'on_hold',
  PENDING_NOTE = 'pending_note',
}

export interface ConditionInfo {
  charge_id: string
  ebt_type: string | null
  id: string
  other_ebt_description: string | null
  other_primary_description: string | null
  other_secondary_description: string | null
  primary_condition: string | null
  primary_condition_severity: string | null
  secondary_condition: string | null
  underassessment_verification: string | null
}

export interface Transfer {
  admin_fee_included: boolean
  admin_note: string | null
  appointment_id: number
  attendance: string
  attestation_data: string | null
  attestation_pre_authorization: boolean
  attestation_status: string | null
  claim_billable_to_customer: string | null
  claim_id: number | null
  client_cost_share_status: string | null
  client_location_country: string | null
  company: string
  condition_info: ConditionInfo
  copay_amount: number
  copay_charge_id: string | null
  copay_charged_amount: number
  copay_consent: boolean
  copay_created_at: string | null
  copay_scheduled_at: string | null
  created_at: string
  current_session_count: string
  date_of_birth: string
  description: string | null
  diagnosis: string
  displayed_company: string
  eligibilityInfo?: [boolean, string, number]
  eligibility_code: string
  eligibility_status: boolean
  eligible_match_status: string | null
  eligible_member_dob: string | null
  eligible_member_first_name: string | null
  eligible_member_gender: string
  eligible_member_last_name: string | null
  eligible_member_lyra_id: string | null
  episode_state: string | null
  exclude_from_session_count: boolean
  first_name: string
  flags_counter: number
  friendly_lyra_code: string | null
  gender: string
  icd10_primary_diagnosis: string | null
  icd10_secondary_diagnosis: string | null
  id: string
  infraction_amount: number
  infraction_charge_id: string | null
  is_guaranteed_time: boolean | null
  is_health_plan: boolean
  is_too_frequent: boolean
  is_too_frequent_with_charge_ids: { date_of_service: string; id: string }[]
  last_name: string
  last_session: boolean
  last_session_terminated: boolean
  lyra_code: string
  modality: string
  notes: string | null
  onsite_session: string | null
  other_diagnosis: string | null
  other_session_description: string | null
  outcomes_opt_out: string | null
  paid_amount: string
  payment_type?: string
  patient_contact_number: string | null
  patient_email: string | null
  patient_is_reconciled: boolean
  patient_lyra_id: string
  patient_match_status: string | null
  patient_source: string
  practice_admin_email: string | null
  practice_admin_id: string | null
  practice_id: string | null
  practice_name: string | null
  program_description: string
  provider_first_name: string
  provider_last_name: string
  provider_location_country: string
  provider_location_state: string
  provider_location_zipcode: string
  provider_lyra_id: string
  reference_number: string | null
  relationship: string
  session_duration: string
  session_rate: string
  session_type: string
  sessions_remaining: string
  sessions_used: string
  status: string
  transfer_id: string | null
  visit_date: string
}

export interface ChargeCopyPrepopInfo {
  eligible_member_first_name?: string
  eligible_member_last_name?: string
  eligible_member_dob?: string
  provider_lyra_id?: string
  first_name?: string
  last_name?: string
  date_of_birth?: string
  gender?: string
  session_type?: string
  lyra_code?: string
  company?: CustomerInfo[]
  relationship?: string
  diagnosis?: Diagnosis[]
  is_guaranteed_time?: boolean
  session_rate?: string
}

export interface Diagnosis {
  label: string
  value: string
}
